import React, { useEffect, useCallback, useState, useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import {
	colors, Button, TextField, Typography,
	Grid, Select, Card, CardHeader, CardContent,
	Divider, Accordion, AccordionSummary, Checkbox,
	AccordionDetails, FormControlLabel, Tabs, Tab,
	FormControl, FormGroup
} from '@material-ui/core';
import { Page, Header, Map, SelectField, Label, SearchBar, FiltersDrawer } from 'components';
import { enqueueSnackbar } from 'actions';
import { DownloadFile } from 'actions/sessionActions.js';
import { SetFormState, GetRepositoryFiles } from '../../actions/RepositoryExcelActions';
import ExcelUpload from './components/ExcelUpload';
import ExcelTable from './components/ExcelTable';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
	tabs: {
		marginTop: theme.spacing(3),
	},
	content: {
		marginTop: theme.spacing(3),
	},
	generate: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const RepositoryForm = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.repositoryReducer.formState);
	const filesInfo = useSelector((state) => state.repositoryReducer.filesInfo);
	const userId = useSelector(state => state.session.user.id);

	const getData = useCallback(() => {
		dispatch(GetRepositoryFiles(userId));
	}, []);

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className={classes.fields}>
			<Grid container spacing={4}>
				<Grid item md={12} xs={12}>
					<Card>
						{/* <CardHeader
							title="Technology"
						/>
						<Divider /> */}
						<CardContent>
							{/* New row */}
							<Grid container spacing={4}>
								<Grid item md={12} x>
									<ExcelUpload />
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
			<Grid container spacing={4}>
				<Grid item md={12}>
					<Card>
						{/* <CardHeader
							title="Technology"
						/>
						<Divider /> */}
						<CardContent>
							{/* New row */}
							<Grid container spacing={4}>
								<Grid item md={12}>
									<ExcelTable data={filesInfo} />
								</Grid>
							</Grid>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

export default RepositoryForm;
